<template>
	<div class="trade-collect">
		<h2>商标名称征集</h2>
		<div class="trade-collect.form">
			<el-form :model="tradeCollectForm" :rules="tradeCollectFormRules" ref="tradeCollectForm" label-width="100px" class="demo-ruleForm">
				<el-form-item prop="name">
					<el-input v-model="tradeCollectForm.name" placeholder="商标名称"></el-input>
				</el-form-item>
				<el-form-item prop="phone">
					<el-input v-model="tradeCollectForm.phone" placeholder="联系电话"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm('tradeCollectForm')">立即联系</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import '../fetch/formatDate';
	import checkPhone from '../fetch/checkPhone';
	export default{
		data() {
		 return {
				tradeCollectForm: {
					name: '',
					phone: ''
				},
				tradeCollectFormRules: {
					name: [{
						required: true,
						message: '请填写商标名称',
						trigger: 'blur'
					}],
					phone: [{validator: checkPhone, trigger: 'blur'}]
		
				}
			}
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.http.post('IPR_Need',{
							  content:'商标名称：' + this.tradeCollectForm.name,
							  phone :this.tradeCollectForm.phone,
							  type: 2, //商标名称征集
							  name:'商标名称征集测试人员' ,
							  date_time: new Date().format("yyyy-MM-dd hh:mm:ss"),
						}).then(res => {
							if(res.code == 0){
								this.$emit('showTipsEvent', true)
							    this.$refs[formName].resetFields();
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
		}
	}
</script>

<style lang="scss">
	@include component(trade-collect){
		width: 100%;
		//height:350px;
		background:linear-gradient(135deg,rgba(84,167,240,1) 0%,rgba(137,200,255,1) 100%);
		box-shadow:0px 0px 10px 0px rgba(0, 0, 0, 0.1);
		color: #fff;
		margin-top:10px;
		h2{
			margin: 0;
			font-size:24px;
			text-align: center;
			padding-top: 19px;
			padding-bottom: 16px;
		}
	   @include part(form){
		   width: 190px;
		   margin: 0 auto;
		   @include component(el-form-item__content) {
		   	margin-left: 0 !important;
		   }
		   
		   @include component(el-form) {
		     padding-bottom: 5px;
		   
		   }
		   @include component(el-input__inner){
		   			   border: none;
		   			   outline: none;
		   }
		   @include component(el-form-item){
			   margin-bottom: 15px;
		   }
		   @include component(el-button) {
		   	width: 100%;
		   	background: #F47227;
		   	border: none;
		   }
		   @include component(el-form-item__error){
		   		top: 91%;
		   }
		 
		   
		   @include component(el-button--primary) {
			  background:linear-gradient(90deg,rgba(255,155,0,1) 0%,rgba(254,191,0,1) 100%);
			   box-shadow:0px 2px 5px 0px rgba(0, 0, 0, 0.2);
			   border-radius:5px;
			  
			   font-weight:bold;
			   font-size:18px;
			   
		   	&:active,
		   	&:hover,
		   	&:focus {
		   		background:linear-gradient(90deg,rgba(255,155,0,1) 0%,rgba(254,191,0,1) 100%);
				 
		   	}
		   
		   	&.is-active {
		   		background:linear-gradient(90deg,rgba(255,155,0,1) 0%,rgba(254,191,0,1) 100%);
				 
		   	}
		   }
	   }
	}
</style>
